export const phoneRegex = /^(?:\+98|0098|98|0)?9\d{9}$/;
